import { z } from 'zod';
import { digitsOnly } from '@/shared/lib/masks';
import type { BillingInfo, PersonType } from '../types/billing.types';

/**
 * Dados de cobrança digitados pelo dono, com as mesmas regras do formulário
 * de assinatura. A API continua sendo a autoridade (`BillingInfoValidator`).
 */
export const billingInfoSchema = z.object({
  name: z.string().min(3, 'Nome deve ter pelo menos 3 caracteres'),
  email: z.string().email('E-mail inválido'),
  phone: z.string().min(10, 'Telefone inválido'),
  document: z.string().min(11, 'Documento inválido'),
  zipCode: z.string().min(8, 'CEP inválido'),
});

export type BillingInfoFormData = z.infer<typeof billingInfoSchema>;

/** O corpo `billingInfo` da API: só dígitos, telefone com +55. */
export function toBillingInfo(personType: PersonType, data: BillingInfoFormData): BillingInfo {
  return {
    personType,
    name: data.name,
    email: data.email,
    phone: '+55' + digitsOnly(data.phone),
    document: digitsOnly(data.document),
    zipCode: digitsOnly(data.zipCode),
  };
}
